import React from 'react';
import Image from 'next/image';

import styles from './ProductsSectionFiber.module.scss';

const ProductsSectionFiber = ({ data }) => {
  const text = data?.title?.split(' ');

  return (
    <div className='wrapper' itemScope itemType='https://schema.org/Product'>
      <div className={styles.inner_wrapper}>
        <div className={styles.top_wrapper}>
          <div className={styles.title_container}>
            {text?.map((des, index) => (
              <div key={index} className={styles.titles}>
                {des?.trim()}
              </div>
            ))}
          </div>
          <p className={styles.info_text}>{data?.description}</p>
        </div>
        <div className={styles.bottom_wrapper}>
          {data?.devices?.map((product) => (
            <div key={product?.id} className={styles.product_container}>
              <p className={styles.product_name}>{product?.title}</p>
              <Image
                src={product?.image}
                alt={product?.title}
                title={product?.title}
                width={332}
                height={336}
                className={styles.img}
              />
              <p className={styles.description}>{product?.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductsSectionFiber;
